export default "<h1><ng-content></ng-content></h1>\r\n"